import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/')({
    beforeLoad: () => {
        throw redirect({ to: '/admin-console/advanced/db-upgrades', replace: true });
    },
});
